export const formQuestionHasPositiveAnswer = (question) => {
  return (
    question?.items?.length > 0 ||
      question?.investments_out_of_xp?.has_investments_out_of_xp ||
      question?.answer?.agreed ||
      question?.answer?.items?.length > 0
    
  )
}
